import React, { Component } from "react";
import CreateHeader from "./Create/CreateHeader";
import CreateInputFiles from "./Create/CreateInputFiles";
import InsInput from "../InsInput/InsInput";
import InsAutocomplete from "../InsAutocomplete/InsAutocomplete";
import { getBrandsList } from "../../api/brands";
import {
  getAllThemes,
  getProductsByThemes,
  getAllProducts,
} from "../../api/wall";
import * as loadImage from "blueimp-load-image";
import { Trans } from 'react-i18next';
import InsButton from '../InsButton/InsButton';
import images from '../../ressources/images';
import { connect } from "react-redux";

export class WallForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brandsList: [],
      themesList: [],
      files: [],
      filesUpload: [],
      autocomplete: [],
      acFocus: "",
      brand: "",
      product_name: "",
      theme: "",
      gpdrModal: false,
    };
  }

  componentDidMount() {
    this.getAllbrands();
  }
  _handleChange = (input) => (e) => {
    const value = e.target.value;

    this.setState(
      {
        [input]: value,
      },
      () => {
        if (this.state.brand && !this.state.theme) {
          this.getBrandThemes();
        }
      }
    );
  };
  _handleChangeName = (input) => (e) => {
    const value = e.target.options[e.target.selectedIndex].dataset.name

    this.setState(
      {
        [input]: value,
      }
    );
  };

  _handleChangeProduct = (input) => (e) => {
    const value = e.target.value;

    this.setState(
      {
        [input]: value,
      },
      () => {
        if (this.state.product_name.length >= 5) {
          if (this.handleChangeTimer) {
            clearTimeout(this.handleChangeTimer);
          }
          this.handleChangeTimer = setTimeout(() => {
            this.autocompleteRequest();
          }, 500);
        }
      }
    );
  };

  /**
   * Recuperation des fichiers selectionnés
   */
  _handleInputFiles = async (e) => {
    const { files } = this.state;
    if (e.target.files.length + files.length <= 10) {
      if (e.target.files.length > 10) {
        for (let i = 0; i < 10; i++) {
          files.push(e.target.files[i]);
        }
        this.setState(
          {
            files,
          },
          () => {
            this.setState({ filesUpload: [] });
            this.loadImageUrl(files);
          }
        );
      } else {
        for (let i = 0; i < e.target.files.length; i++) {
          files.push(e.target.files[i]);
        }
        this.setState(
          {
            files,
          },
          () => {
            this.setState({ filesUpload: [] });
            this.loadImageUrl(files);
          }
        );
      }
    }
  };

  loadImageUrl = (files) => {
    files.forEach((file) => {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/gif" &&
        file.type !== "image/png"
      ) {
        this.setState((prevState) => ({
          filesUpload: [...prevState.filesUpload, file],
        }));
      } else {
        loadImage(
          file,
          (canvas) => {
            const base64 = canvas.toDataURL();

            this.setState((prevState) => ({
              filesUpload: [...prevState.filesUpload, base64],
            }));
          },
          {
            orientation: true,
            maxWidth: 1000,
            maxHeight: 1000,
            canvas: true
          }
        );
      }
    });
  };

  /**
   * Affichage autocomplétion
   */
  showAutocomplete = (name) => () => {
    clearTimeout(this.setTimeOutAutoComplete);
    this.setState({ acFocus: name });
  };

  _onClickAutocomplete = (input) => (value) => {
    this.setState(
      {
        [input]: value,
        acAddress: false,
      },
      () => {
        this.autocompleteRequest(true);
        this.showAutocomplete("");
      }
    );
  };

  /**
   * Récupere toutes les marques
   */
  getAllbrands() {
    getBrandsList().then((data) => {
      this.setState({ brandsList: data });
    });
  }

  getBrandThemes() {
    const { brand } = this.state;
    getAllThemes(brand).then((data) => {
      this.setState({ themesList: data });
    });
  }

  /**
   * Recuperation des produits
   */
  autocompleteRequest = (generation = false) => {
    const { product_name, brand } = this.state;

    let obj = {};

    if (brand) {
      obj.brand_id = brand;
      if (product_name.length) obj.name_display = product_name;

      getProductsByThemes(obj).then((data) => {
        this.setState({ autocomplete: data });
        if (generation) {
          Object.keys(data).forEach((item) => {
            if (data[item].length === 1) {
              this.setState({ [item]: data[item][0] });
            }
          });
        }
      });
    } else {
      if (product_name.length) obj.name_display = product_name;

      getAllProducts(obj).then((data) => {
        this.setState({ autocomplete: data });
        if (generation) {
          Object.keys(data).forEach((item) => {
            if (data[item].length === 1) {
              this.setState({ [item]: data[item][0] });
            }
          });
        }
      });
    }
  };

  /**
   * Valide le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { files, brand } = this.state;
    return files.length > 0 && brand !== "";
  };

  render() {
    const {
      brand,
      legend,
      theme,
      brandsList,
      themesList,
      acFocus,
      autocomplete,
      product_name,
      filesUpload,
      gpdrModal
    } = this.state;

    const {
      config,
      loadCreate,
      filesPreview,
      history,
      location,
      optin_wall,
      t,
      optins_link: { tou, gdpr },
    } = this.props;

    const { country } = config;

    return (
      <div>
        <CreateHeader
          loadCreate={loadCreate}
          history={history}
          location={location}
          validate={this._validateFormStep()}
          t={t}
          submitPost={optin_wall ? () =>
            this.props.submitPost(
              brand,
              filesUpload,
              product_name,
              legend,
              theme
            )
            :
            () => this.setState({gpdrModal: true})
          }
        />
        <div className="content">
          <CreateInputFiles
            filesPreview={filesPreview}
            files={filesUpload}
            handleInput={this._handleInputFiles}
            t={t}
          />
          <textarea
            placeholder={t("legend")}
            name="legend"
            onChange={this._handleChange("legend")}
            maxLength="2200"
          ></textarea>
        </div>
        <div className="select_container">
          <div className="select_wrapper">
            <i className="arrow down"></i>
            <select
              name="brand"
              id="brand_select"
              onChange={(e) => {
                this._handleChange("brand")(e);
                this._handleChangeName("brandName")(e);
              }}
              defaultValue={t("brand")}
            >
              <option value={t("brand")} disabled>
                {t("brand")}*
              </option>
              {brandsList.map((brand, index) => (
                <option key={index} value={brand.id} data-name={brand.name}>
                  {brand.name}
                </option>
              ))}
            </select>
          </div>

          <div className="select_wrapper">
            <i className="arrow down"></i>
            <select
              name="theme"
              id="theme_select"
              onChange={(e) => {
                this._handleChange("theme")(e);
              }}
              defaultValue={t("theme")}
            >
              <option value={t("theme")} disabled>
                {t("theme")}
              </option>
              {themesList.map((theme, index) => (
                <option key={index} value={theme.id}>
                  {theme.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="product_name input_container">
          <InsInput
            name="product_name"
            value={product_name}
            onChange={this._handleChangeProduct("product_name")}
            onFocus={this.showAutocomplete("product_name")}
            onBlur={() => {
              this.setTimeOutAutoComplete = setTimeout(() => {
                this.showAutocomplete("")();
              }, 150);
            }}
            type="text"
            placeholder={t("product_name")}
          />
          <InsAutocomplete
            visible={acFocus === "product_name"}
            values={autocomplete}
            onClick={this._onClickAutocomplete("product_name")}
          />
        </div>


        {optin_wall ? (
          <div className="optin_wall_text">
            <Trans
              i18nKey="optin_wall_remind"
              defaults={
                "We remind you that you have agreed by posting content on One Retail to the <link1>Terms of Use</link1> governing the rights granted to L’Oréal Luxe on such content and to the use of your personal data in order for L’Oréal Luxe to publish and manage your post in the condition of the <link2>Privacy Policy</link2>.<br/><br/>You may delete your content at any time in your personal account."
              }
              components={{
                br: <br />,
                link1: (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={tou}
                  />
                ),
                link2: (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={gdpr}
                  />
                ),
              }}
            />
          </div>
        ) : (
          <div className="lol">
            <Trans
              i18nKey="loreal_allowed"
              defaults={
                "By publishing content on One Retail, I accept the <link1>Terms of Use</link1> governing the rights granted to L’Oréal/One Retail over this content, as well as the use of my personal data so that L’Oréal/One Retail can publish and manage my post according to the conditions of the <link2>Privacy Policy</link2>.<br/> <br/>You can delete your content at any time from your personal account. One Retail is a platform of L’Oréal"
              }
              components={{
                br: <br />,
                link1: (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={tou}
                  />
                ),
                link2: (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={gdpr}
                  />
                ),
              }}
            />
          </div>
        )
        }
        {gpdrModal &&
          <div className="gpdr_modal">
            <div className="close_modal" onClick={() => this.setState({gpdrModal: false})}>
              <img src={images.closeCross} alt=""/>
            </div>
            <div className="modal_content">
              <div className="picto">
                <img src={images.camera} alt=""/>
              </div>
              <div className="text">
                  <Trans
                        i18nKey="optin_wall"
                    >
                    By posting content on One Retail I agree to the <a target="_blank" rel="noopener noreferrer"
                                                                         href={tou}>Terms of
                    Use</a> governing the rights granted to L’Oréal {country} on such content and to the use of my
                    personal data in order for L’Oréal {country} to publish and manage my post in the condition of
                    the <a target="_blank" rel="noopener noreferrer" href={gdpr}>Privacy
                    Policy.</a><br/><br/>
                    You may delete your content at any time in your personal account.<br/><br/>
                    L’Oréal Luxe is part of L’Oréal {country}.
                  </Trans>
              </div>
            </div>
            <div className="accept">
              <InsButton
                type="default"
                text={t('accept_publish')}
                onClick={() => this.props.submitPost(
                  brand,
                  filesUpload,
                  product_name,
                  legend,
                  theme
                )}
              />
            </div>
            <div className="cancel" onClick={() => this.setState({gpdrModal: false})}>{t('cancel')}</div>
          </div>
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config
})

export default connect(mapStateToProps)(WallForm);
